import { useState, useEffect } from 'react';

function useFocusVisibleMode() {
    const [hadKeyboardEvent, setHadKeyboardEvent] = useState(false);
    useEffect(() => {
        const handleKeyDown = (e) => {
            // Ignore modifier-only keys
            if (e.metaKey || e.altKey || e.ctrlKey)
                return;
            setHadKeyboardEvent(true);
        };
        const handlePointer = () => {
            setHadKeyboardEvent(false);
        };
        window.addEventListener("keydown", handleKeyDown, true);
        window.addEventListener("mousedown", handlePointer, true);
        window.addEventListener("pointerdown", handlePointer, true);
        window.addEventListener("touchstart", handlePointer, true);
        return () => {
            window.removeEventListener("keydown", handleKeyDown, true);
            window.removeEventListener("mousedown", handlePointer, true);
            window.removeEventListener("pointerdown", handlePointer, true);
            window.removeEventListener("touchstart", handlePointer, true);
        };
    }, []);
    return hadKeyboardEvent;
}

export { useFocusVisibleMode };
